<h4 class="mt-4">Transporte Aereo</h4>
<mat-grid-list cols="2" rowHeight="100px" height="400px">
    <mat-grid-tile>
        <mat-form-field appearance="fill" [formGroup]="FormTransporte">
            <mat-label>Seleccione una el transporte aéreo</mat-label>
            <mat-select formControlName="transporte" name="transporte"
                (selectionChange)="asignTransport($event.value)">
                <mat-option *ngFor="let transporte of taereos" [value]="transporte.id">
                    {{transporte.attributes?.numPermisoSCT}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button
            (click)="deleteTransporte()">Eliminar</button>
        <button class="fuse-mat-button-rounded mgbutton" mat-flat-button (click)="saveTransporte()"
            [color]="'primary'">Guardar</button>
    </mat-grid-tile>
</mat-grid-list>
<!---->
<div class="row">
    <div class="col-sm-6">
        <div class="border" style="margin-right: 10px; padding: 15px">
            <div class="row">
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>PermSCT </mat-label>
                        <mat-select name="PermSCT" formControlName="PermSCT">
                            <mat-option *ngFor="let PermSCT of PermSCTList" [value]="PermSCT.id">
                                {{PermSCT.attributes?.clave}} - {{PermSCT.attributes?.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div *ngIf="FormTransporte.controls.PermSCT.invalid && FormTransporte.controls.PermSCT.touched">
                        <div *ngIf="FormTransporte.controls.PermSCT.errors.required"
                            style="font-size: 12px;color: red;">El campo es requerido.</div>
                    </div>
                </div>

                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NumPermisoSCT </mat-label>
                        <input matInput formControlName="NumPermisoSCT">
                    </mat-form-field>
                    <div
                        *ngIf="FormTransporte.controls.NumPermisoSCT.invalid && FormTransporte.controls.NumPermisoSCT.touched">
                        <div *ngIf="FormTransporte.controls.NumPermisoSCT.errors.required"
                            style="font-size: 12px;color: red;">El campo es requerido.</div>
                    </div>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>MatriculaAeronave </mat-label>
                        <input matInput formControlName="MatriculaAeronave">
                    </mat-form-field>
                    <div
                        *ngIf="FormTransporte.controls.MatriculaAeronave.invalid && FormTransporte.controls.MatriculaAeronave.touched">
                        <div *ngIf="FormTransporte.controls.MatriculaAeronave.errors.required"
                            style="font-size: 12px;color: red;">El campo es requerido.</div>
                    </div>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NumeroGuia </mat-label>
                        <input matInput formControlName="NumeroGuia">
                    </mat-form-field>
                    <div
                        *ngIf="FormTransporte.controls.NumeroGuia.invalid && FormTransporte.controls.NumeroGuia.touched">
                        <div *ngIf="FormTransporte.controls.NumeroGuia.errors.required"
                            style="font-size: 12px;color: red;">El campo es requerido.</div>
                    </div>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NombreAseg</mat-label>
                        <input matInput formControlName="NombreAseg">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NumPolizaSeguro</mat-label>
                        <input matInput formControlName="NumPolizaSeguro">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>LugarContrato</mat-label>
                        <input matInput formControlName="LugarContrato">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>CodigoTransportista </mat-label>
                        <mat-select name="CodigoTransportista" formControlName="CodigoTransportista">
                            <mat-option *ngFor="let codigo of codigosTransportista" [value]="codigo.id">
                                {{codigo.attributes?.clave}} - {{codigo.attributes?.nombreAerolinea}}
                            </mat-option>
                        </mat-select>
                        <!-- <input matInput formControlName="CodigoTransportista"> -->
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!--  -->
    </div>
    <div class="col-sm-6">
        <div class="border" style="margin-right: 10px; padding: 15px">
            <div class="row">
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>RFC Transportista</mat-label>
                        <input matInput formControlName="RFCTransportista">
                        <mat-error *ngIf="FormTransporte.controls['RFCTransportista'].invalid">
                            RFC no válido
                        </mat-error>
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NombreTransportista</mat-label>
                        <input matInput formControlName="NombreTransportista">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte"
                        [matTooltipPosition]="'above'" matTooltip="Si no se registra valor en el atributo “RFCTransportista”,
                    este atributo debe contener un valor que corresponda a
                    alguna de las claves del catálogo “Pais”.">
                        <mat-label>ResidenciaFiscalTranspor <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <mat-select name="ResidenciaFiscalTranspor" formControlName="ResidenciaFiscalTranspor"
                            (selectionChange)="onSelectOption(1,$event.value)">
                            <mat-option *ngFor="let pais of paises" [value]="pais.id">
                                {{pais.attributes?.idPais }} - {{ pais.attributes?.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte"
                        [matTooltipPosition]="'above'" matTooltip="Cuando exista el atributo “RFCTransportista”, este
                    atributo se debe omitir, en caso de que el transportista sea
                    extranjero este atributo debe contener un valor, para lo
                    cual se debe identificar el país de residencia para efectos
                    fiscales del transportista de acuerdo a la clave del país de
                    residencia fiscal">
                        <mat-label>NumRegIdTribTranspor <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="NumRegIdTribTranspor">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>RFC Embarcador</mat-label>
                        <input matInput formControlName="RFCEmbarcador">
                        <mat-error *ngIf="FormTransporte.controls['RFCEmbarcador'].invalid">
                            RFC no válido
                        </mat-error>
                    </mat-form-field>
                    
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte">
                        <mat-label>NombreEmbarcador</mat-label>
                        <input matInput formControlName="NombreEmbarcador">
                    </mat-form-field>
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte"
                        [matTooltipPosition]="'above'" matTooltip="Si no se registra valor en el atributo “RFCEmbarcador”,
               este atributo debe contener un valor que corresponda a alguna de las claves del catálogo “Pais”">
                        <mat-label>ResidenciaFiscalEmbarc <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <mat-select name="ResidenciaFiscalEmbarc" formControlName="ResidenciaFiscalEmbarc"
                            (selectionChange)="onSelectOption(2, $event.value)">
                            <mat-option *ngFor="let pais of paises" [value]="pais.id"
                                [selected]="pais.idPais === FormTransporte.get('ResidenciaFiscalEmbarc').value">
                                {{ pais.attributes?.idPais }} - {{pais.attributes?.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte"
                        [matTooltipPosition]="'above'" matTooltip="Si no se registra valor en el atributo “RFCEmbarcador”,
                    este atributo debe contener un valor que corresponda a
                    alguna de las claves del catálogo “Pais”">
                        <mat-label>ResidenciaFiscalEmbarc <mat-icon class="mat-18">info</mat-icon> </mat-label>
                        <mat-select name="ResidenciaFiscalEmbarc" formControlName="ResidenciaFiscalEmbarc"
                            (selectionChange)="onSelectOption(2,$event.value)">
                            <mat-option *ngFor="let pais of paises" [value]="pais.idPais">
                                {{pais.nombre}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->
                </div>
                <!--  -->
                <div class="col-sm-6">
                    <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormTransporte"
                        [matTooltipPosition]="'above'" matTooltip="Cuando existe el atributo “RFCEmbarcador”, este atributo
                    se debe omitir, en caso de que el embarcador sea
                    extranjero este atributo debe contener un valor, para lo
                    cual se debe identificar el país de residencia para efectos
                    fiscales del embarcador, de acuerdo a la clave del país de
                    residencia fiscal.">
                        <mat-label>NumRegIdTribEmbarc <mat-icon class="mat-18">info</mat-icon></mat-label>
                        <input matInput formControlName="NumRegIdTribEmbarc">
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
</div>